import React from 'react';

interface Props {}

export const End: React.FC<Props> = () => {
  return null;
};
